import { contains, dentablePanels, glassPanels, guessTemplate, interior, tyres, wheels } from "./DefectJobTypeGuesser";
import { isString } from "lodash";
function locateForDefect(templates, defect) {
    // @ts-ignore
    let strategy = window.marque.ui.inspectionMappings.bodywork.strategy;
    if (isString(strategy)) {
        strategy = [strategy];
    }
    for (let x of strategy) {
        let result;
        if (x === 'guess') {
            result = guessTemplate(templates, defect);
        }
        else if (x === 'panel') {
            result = locateTemplateUsingPanelStrategy(templates, defect);
        }
        else if (x === 'defect_type') {
            result = locateTemplateUsingDefectTypeStrategy(templates, defect);
        }
        if (result) {
            return result;
        }
    }
    return null;
}
function locateTemplateUsingPanelStrategy(templates, defect) {
    const mappings = window.marque.ui.inspectionMappings.bodywork.panel_mappings;
    let templateId;
    if (dentablePanels.find(i => contains(i, defect.panel ?? ''))) {
        templateId = mappings['body'];
    }
    else if (glassPanels.find(i => contains(i, defect.panel ?? ''))) {
        templateId = mappings['glass'];
    }
    else if (wheels.find(i => contains(i, defect.panel ?? ''))) {
        templateId = mappings['wheels'];
    }
    else if (tyres.find(i => contains(i, defect.panel ?? ''))) {
        templateId = mappings['tyres'];
    }
    else if (interior.find(i => contains(i, defect.panel ?? ''))) {
        templateId = mappings['interior'];
    }
    if (templateId) {
        return locateTemplateByMapping(templateId, templates);
    }
    return null;
}
function locateTemplateUsingDefectTypeStrategy(templates, defect) {
    const mappings = window.marque.ui.inspectionMappings.bodywork.defect_type_mappings;
    if (defect.type) {
        return locateTemplateByMapping(mappings[defect.type], templates);
    }
    return null;
}
function locateTemplateByMapping(mapping, templates) {
    const options = [];
    templates.forEach(template => {
        if (template.options.length > 0) {
            template.options.forEach(option => {
                options.push(option);
            });
        }
    });
    const template = templates.find((template) => mapping?.type === 'task.template' && template.id === mapping?.id);
    const templateOption = options.find(option => mapping?.type === 'task.template.option' && option.id === mapping?.id);
    if (template) {
        return {
            template,
            option: { id: template.id, type: 'task.template' },
        };
    }
    else if (templateOption) {
        return {
            template: templateOption,
            option: { id: templateOption.id, type: 'task.template.option' },
        };
    }
    return null;
}
export { locateForDefect };
